const menuData = [{
        id: '1',
        label: '首页',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon1-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon1-1.png",
        path: '/index'
    },
    {
        id: '2',
        label: '榜单',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon2-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon2-1.png",
        children: [{
                id: '2-1',
                fatherId: '2',
                label: '短剧热度榜',
                path: '/adRankList'
            },
            {
                id: '2-2',
                fatherId: '2',
                label: '演员星耀榜',
                path: '/actorRankList'
            },
            {
                id: '2-3',
                fatherId: '2',
                label: '原生播放榜',
                path: '/playRankList'
            }, {
                id: '2-4',
                fatherId: '2',
                label: '快手短剧榜',
                path: '/ksRankList'
            }, {
                id: '2-5',
                fatherId: '2',
                label: '品牌榜',
                path: '/brandRankList'
            },
            // {
            //   id: '2-5',
            //   fatherId: '2',
            //   label: '女演员榜',
            //   path: '/grilActorRankList'
            // }, {
            //   id: '2-6',
            //   fatherId: '2',
            //   label: '男演员榜',
            //   path: '/manActorRankList'
            // }
        ]
    }, {
        id: '3',
        label: '找热剧',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon3-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon3-1.png",
        path: '/hotRankList'
    }, {
        id: '4',
        label: '找公司',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon5-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon5-1.png",
        path: '/company'
    }, {
        id: '5',
        label: '找素材',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon4-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon4-1.png",
        path: '/awemeRankList'
    }, {
        id: '6',
        label: '找漫剧',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon4-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon4-1.png",
        path: '/animation'
    },
    // {
    //   id: '6',
    //   label: '备案服务',
    //   icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon6-0.png",
    //   iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon6-1.png",
    //   children: [{
    //       id: '6-1',
    //       fatherId: '6',
    //       label: '我需要备案',
    //       path: '/filingService'
    //     },
    //     {
    //       id: '6-2',
    //       fatherId: '6',
    //       label: '查看备案进度',
    //       path: '/userinfo'
    //     },
    //   ]
    // },
    //  {
    //   id: '7',
    //   label: '版权交易',
    //   icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon7-0.png",
    //   iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon7-1.png",
    //   children: [{
    //       id: '7-1',
    //       fatherId: '7',
    //       label: '我要买版权',
    //       path: ''
    //     },
    //     {
    //       id: '7-2',
    //       fatherId: '7',
    //       label: '我要卖版权',
    //       path: ''
    //     },
    //   ]
    // },
    {
        id: '8',
        label: '工作台',
        icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon8-0.png",
        iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon8-1.png",
        children: [{
                id: '8-1',
                fatherId: '8',
                label: '个人中心',
                path: '/userinfo'
            },
            {
                id: '8-2',
                fatherId: '8',
                label: '我的收藏',
                path: '/myCollect'
            },
            {
                id: '8-3',
                fatherId: '8',
                label: '我的订单',
                path: '/myOrder'
            },
            // {
            //   id: '8-3',
            //   fatherId: '8',
            //   label: '我的版权',
            //   path: ''
            // },
            // {
            //   id: '8-4',
            //   fatherId: '8',
            //   label: '我的备案',
            //   path: ''
            // },
        ]
    }
    // ,{
    //   id: '9',
    //   label: 'WETELAX',
    //   icon: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon1-0.png",
    //   iconActived: "https://sycsp-img01.oss-cn-beijing.aliyuncs.com/wetrueWeb/icon1-1.png",
    //   path: '/werelax'
    // },
]
export default menuData;


// WEBPACK FOOTER //
// ./src/utils/menu.js